import { LOCATION_CHANGED } from 'redux-little-router'
import { setLastProjectsUrl } from './actions/app'
import { fetchVenues } from './actions/venue'

export const fetcher = store => next => (action) => {
  if (action.type === LOCATION_CHANGED) {
    store.dispatch(fetchVenues(action.payload.query))
  }
  return next(action)
}

export const lastProjectsUrlSetter = store => next => (action) => {
  if (action.type === LOCATION_CHANGED) {
    store.dispatch(setLastProjectsUrl(
      action.payload.pathname,
      action.payload.search,
    ))
  }
  return next(action)
}
